import { IHomePlanBlueprint } from '@/components/organisms/or-floorplan-viewer/or-floorplan-viewer.types';
import { getStudioModelHomes } from '@/lib/data/getStudioModelHomes';
import { ITmModelHomeDetailCSProps } from './tm-model-home-detail.types';
import { IDesignStudio } from '@/components/organisms/or-design-studio-block/or-design-studio-block.types';

export async function fetchModelHomeDetailData(
  block: ITmModelHomeDetailCSProps,
  studioData: IDesignStudio[],
) {
  const {
    model_home_id,
    studio_id,
    custom_name_for_additional_model_home_data,
  } = block;

  const studioId = studio_id.location[0];

  const currentBuildStudio = studioData.find(
    (studio) => studio.Id === Number(studioId),
  );

  const models = await getStudioModelHomes(Number(studioId));

  const modelHomeId = model_home_id?.model_id;
  const currentHome = models.find(
    (model) => Number(model.Id) === Number(modelHomeId),
  );
  const additionalHomes = models.filter(
    (model) => Number(model.Id) !== Number(modelHomeId),
  );

  const floorPlans: IHomePlanBlueprint[] = [];
  currentHome?.FloorPlans?.forEach(({ FloorPlanImages }) => {
    FloorPlanImages?.forEach((floorPlan) => {
      floorPlans.push({
        title: floorPlan.Type,
        subtitle: undefined,
        image: {
          alt: `${floorPlan.TypeId}_${floorPlan.Type}`,
          priority: false,
          src: {
            mobile: floorPlan.FileName,
            tablet: floorPlan.FileName,
            desktop: floorPlan.FileName,
          },
        },
      });
    });
  });

  const additionalModelHomesLabel =
    additionalHomes.length === 1
      ? `Additional Model Home of ${custom_name_for_additional_model_home_data || currentBuildStudio?.CsName || currentBuildStudio?.Name}`
      : `Additional Model Homes of ${custom_name_for_additional_model_home_data || currentBuildStudio?.CsName || currentBuildStudio?.Name}`;

  return {
    studio: currentBuildStudio,
    currentModelData: currentHome ? [currentHome] : [],
    additionalModelData: additionalHomes,
    floorPlans,
    additionalModelHomesLabel,
  };
}
